"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.channels.title': '渠道集成',
    'socialMediaPlan.channels.desc': '连接您的社交媒体账户。',
};
